import { Link } from "react-router-dom";
import { stepsData } from "../lib/data";
import { Reveal } from "../components/Reveal";
import { useLang } from "../context/LanguageContext";
import { useImages } from "../context/ContentContext";

export default function Rituel() {
  const { t, lang } = useLang();
  const IMG = useImages();
  const STEPS = stepsData(lang);
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-6 text-center mb-16">
        <Reveal>
          <p className="overline mb-4">{t("rituel.overline")}</p>
          <h1 className="font-display text-5xl md:text-7xl mb-6" style={{ fontWeight: 300 }}>{t("rituel.title_pre")}<span className="rose-gold-text italic">LUXE ORYVEA</span>{t("rituel.title_suf")}</h1>
          <p className="text-sm max-w-lg mx-auto" style={{ color: "var(--lo-muted)" }}>{t("rituel.intro")}</p>
        </Reveal>
      </div>

      <Reveal><div className="max-w-6xl mx-auto px-6 md:px-12 mb-20">
        <img src={IMG.ritual} alt="Rituel" loading="lazy" decoding="async" className="w-full h-[420px] md:h-[560px] object-cover" style={{ border: "1px solid var(--lo-border-rose)" }} />
      </div></Reveal>

      <div className="max-w-5xl mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1}>
            <div className="card-lux p-10 h-full" data-testid={`rituel-step-${i}`}>
              <span className="font-display text-5xl rose-gold-text italic block mb-6" style={{ fontWeight: 300 }}>{s.n}</span>
              <h3 className="font-display text-2xl mb-3" style={{ fontWeight: 400 }}>{s.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "var(--lo-muted)" }}>{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="text-center mt-16">
        <Link to="/serum" className="btn-primary inline-flex items-center h-14 px-10" data-testid="rituel-cta">{t("rituel.cta")}</Link>
      </div>
    </div>
  );
}
